
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoInvoiceReceiveEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoInvoiceReceiveRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoInvoiceReceiveRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
